const state = {
  searchParams: {},
  reports: [],
  triggeredReports: [],
};

export default state;
